import styled from 'styled-components'

import { useTranslation } from 'react-i18next'

import { Box } from '../Box'
import { Flex } from '../Flex'
import { Title, Text } from '../Text'
import { Link } from '../Link'
import { Image } from '../Image'

const NewsContainer = styled(Box)`
  box-shadow: 0px 10px 14px 5px ${({ theme }) => theme.colors.borderPrimary};
  transition: all 0.2s ease-in-out;
  border-radius: 4px;

  &:hover {
    transform: scale(1.05);
  }
`
const NewsImage = styled(Image)<{ src: string }>`
  width: 100%;
  height: 150px;
  background: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px 4px 0 0;
`

export type Props = {
  image?: string
  title: string
  desc: string
  width: any
}

export const News = ({ image, width, title, desc }: Props) => {
  const { t } = useTranslation('core')
  return (
    <Box width={width} padding={2}>
      <NewsContainer>
        {image && <NewsImage src={image} />}
        <Box padding="16px">
          <Flex flexDirection="column">
            <Title level="medium" text={title} />
            <Text color="darkGray" block marginY="16px">
              {desc}
            </Text>

            <Link to="/">
              <Text color="primary" block>
                {t('ReadMore')}
              </Text>
            </Link>
          </Flex>
        </Box>
      </NewsContainer>
    </Box>
  )
}
